var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploadFiledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07523 3.43211C4.88592 1.51407 6.78473 0.166992 8.99954 0.166992C11.8278 0.166992 14.143 2.36425 14.3311 5.14486C16.2349 5.38229 17.7081 7.00635 17.7081 8.97447C17.7081 11.106 15.9801 12.8339 13.8486 12.8339H9.5933V7.73604L10.5589 8.70158C10.7908 8.93347 11.1667 8.93347 11.3986 8.70158C11.6305 8.4697 11.6305 8.09381 11.3986 7.86192L9.41937 5.88271C9.18748 5.65083 8.81159 5.65083 8.57971 5.88271L6.60047 7.86192C6.3686 8.09381 6.3686 8.4697 6.60047 8.70158C6.83235 8.93347 7.20831 8.93347 7.44016 8.70158L8.40577 7.73604V12.8339H5.04112C2.41771 12.8339 0.291016 10.7072 0.291016 8.08383C0.291016 5.79119 1.91478 3.8786 4.07523 3.43211Z",
    fill: "#151918",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadFiledIcon);
export default __webpack_public_path__ + "static/media/FileUploadFiledIcon.e5bb597f23e7d35352d4d2ce76d8611e.svg";
export { ForwardRef as ReactComponent };